<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-space-y-4">
    <div class="pos pos-counter">
      <div class="pos-counter-body">
        <div class="pos-counter-content">
          <vue-custom-scrollbar class="pos-counter-content-container">
            <ts-loading-banner :loading="false">
              <div class="table-row">
                <TableCard v-for="(table, index) in tableLists" :key="index" :table="table"
                  :selected="checkSelected(table)" @click="onTableSelected(table)" />
              </div>
            </ts-loading-banner>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>
    <div class="btn-row ts-space-x-2 ts-text-right">
      <ts-button @click.prevent="$emit('cancel')"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
        {{ $t('restaurantSale.back') }}</ts-button>
      <ts-button color="success" @click.prevent="linkedKey" :waiting="loading"
        :disabled="loading || (tableSelected.table_id ? false : true)"><i class="fa fa-shopping-cart fa-fw fa-lg"
          v-if="!loading"></i>
        {{ $t('restaurantSale.linkedKey') }}</ts-button>
    </div>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import RecieptPreview from './reciept-preview'
import TableCard from './LinkedKeysTableCard.vue'

export default {
  props: ['tableSelected'],
  name: 'linkedKeys',
  components: {
    RecieptPreview,
    TableCard
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        table_id: null,
        stock_out_id: null,
        linked_keys: [],
      },
      waiting: false,
    }
  },
  created() {
    this.setEditData(this.tableSelected)
  },
  computed: {
    tableLists() {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
        .filter(table => table.status_id == 1 || this.tableSelected.linked_keys.some(el => el.table_id == table.table_id))
    },
    maxPerson() {
      return Math.max(
        ...this.tableSelected.invoice_detail.map(el => el.max_person)
      );
    },
  },
  methods: {
    checkSelected(table) {
      const selected = this.model.linked_keys.find(el => el.table_id == table.table_id)
      return selected ? true : false
    },
    onTableSelected(table) {
      const selected = this.model.linked_keys.find(el => el.table_id == table.table_id)
      if (selected) {
        this.model.linked_keys.splice(
          this.model.linked_keys.indexOf(selected),
          1
        )
      } else {
        if (this.model.linked_keys.length >= this.maxPerson) {
          this.$notification['error']({
            message: 'LINKED KEY',
            description: 'Max Person Exceeded! (max person: ' + this.maxPerson + ')',
            placement: 'bottomRight'
          })
          return 0;
        }

        let row = {
          stock_out_linked_key_id: null,
          stock_out_id: this.model.stock_out_id,
          table_id: table.table_id,
          start_time: null,
          end_time: null
        }
        this.model.linked_keys.push(row)
      }
    },
    linkedKey() {
      this.loading = true
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/linkedKey', this.model)
        .then(response => {
          this.$notification['success']({
            message: 'LINKED KEY',
            description: response.message,
            placement: 'bottomRight'
          })
          this.$emit('cancel')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$notification['error']({
            message: 'LINKED KEY',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    setEditData(tableSelected) {
      this.model.table_id = tableSelected.table_id
      this.model.stock_out_id = tableSelected.stock_out_id
      this.model.linked_keys = tableSelected.linked_keys.map(el => ({
        stock_out_linked_key_id: el.stock_out_linked_key_id,
        stock_out_id: el.stock_out_id,
        table_id: el.table_id,
        start_time: el.start_time,
        end_time: el.end_time
      }))
    }
  }
}
</script>
<style scoped>
.btn-row .btn {
  padding: 15px 20px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}

fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>

<style scoped>
.pos-counter {
  height: auto !important;
  padding-top: 0;
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }

  .pos-counter {
    height: 107vh;
  }
}
</style>
<style>
.ant-notification {
  z-index: 1030;
}
</style>